import { useEffect, useState } from "react";
import { vendorFlags } from "./api";
import { useAuthUser } from "./useAuthUser";

const OFF = { claiming: false, starter: false, badges: false, admin_preview: false };
// Cache flags per signed-in identity. The server elevates `claiming`/`starter`
// for admins and verified owners, so an anonymous (dark-launch) result must NOT
// bleed into the signed-in state — otherwise the vendor dashboard stays "not
// available" even after an admin/owner logs in.
const cache = new Map(); // key: lowercased email or "anon" -> flags

export function useVendorFlags() {
  const { user, loading: authLoading } = useAuthUser();
  const key = user?.email ? user.email.toLowerCase() : "anon";
  const [flags, setFlags] = useState(cache.get(key) || OFF);
  const [loading, setLoading] = useState(!cache.has(key));

  useEffect(() => {
    if (authLoading) return; // wait until we know who the viewer is before fetching
    if (cache.has(key)) {
      setFlags(cache.get(key));
      setLoading(false);
      return;
    }
    let mounted = true;
    setLoading(true);
    vendorFlags()
      .then((f) => {
        cache.set(key, f);
        if (mounted) {
          setFlags(f);
          setLoading(false);
        }
      })
      .catch(() => {
        if (mounted) {
          setFlags(OFF);
          setLoading(false);
        }
      });
    return () => {
      mounted = false;
    };
  }, [key, authLoading]);

  return { flags, loading };
}
